import { useNav } from "@pomle/react-router-paths";
import { paths } from "render/routes/paths";
import { Typography } from "render/ui/presentation/Typography";
import { ActionButton } from "render/ui/trigger/ActionButton";
import { Trans } from "../../../../trans";

interface CheckInErrorProps {
  message: string | JSX.Element;
}

export function CheckInError({ message }: CheckInErrorProps) {
  const nav = {
    root: useNav(paths.root),
  };

  return (
    <div>
      <Typography style={{ marginBottom: "4px" }} variant="title-large">
        <Trans.WeCouldntCheckYouIn />
      </Typography>
      <Typography
        style={{ marginBottom: "48px" }}
        variant="title-medium"
        color="subtle"
      >
        {message}
      </Typography>
      <ActionButton onClick={() => nav.root.go({})}>
        <Trans.GoBack />
      </ActionButton>
    </div>
  );
}
